"use strict";

exports.__esModule = true;
exports.updateValueBySchema = void 0;

var _buildTagByValue = require("../utils/build-tag-by-value");

var _isEmpty = require("../../utils/is-empty");

var _validateTagStructure = require("../utils/validate-tag-structure");

var updateValueBySchema = function updateValueBySchema(tags, tagSchema, value, meta) {
  if (tags === void 0) {
    tags = [];
  }

  if ((0, _isEmpty.isEmpty)(value)) {
    return removeTagBySchema(tags, tagSchema);
  }

  var tag = (0, _buildTagByValue.buildTagByValueAndSchema)(value, tagSchema);

  if ((0, _isEmpty.isEmpty)(tag)) {
    return tags;
  }

  if (meta) {
    tag.meta = meta;
  }

  var tagIndex = findTagIndexBySchema(tags, tagSchema);
  var newTags = replaceOrInsertTag(tags, tagIndex, tag);
  return newTags;
};

exports.updateValueBySchema = updateValueBySchema;

function findTagIndexBySchema(tags, tagSchema) {
  if ((0, _isEmpty.isEmpty)(tagSchema) || (0, _isEmpty.isEmpty)(tags)) {
    return -1;
  }

  var tagIndexDistanceFromEnd = tags.slice().reverse().findIndex(function (tag) {
    return (0, _validateTagStructure.validateTagStructure)(tag, tagSchema);
  });
  return tags.length - 1 - tagIndexDistanceFromEnd;
}

function removeTagBySchema(tags, tagSchema) {
  var tagIndex = findTagIndexBySchema(tags, tagSchema);
  return tagIndex !== -1 ? tags.slice(0, tagIndex).concat(tags.slice(tagIndex + 1, tags.length)) : tags;
}

function replaceOrInsertTag(tags, tagIndex, newTag) {
  var updatedTags = tags.slice();

  if (tagIndex !== -1) {
    updatedTags[tagIndex] = newTag;
  } else {
    updatedTags.push(newTag);
  }

  return updatedTags;
}